module.exports = __webpack_public_path__ + "img/kazakhstan.09c40dc4.svg";